(ns hypnos.dme.tile.field.patient-mask
  "Field for mask seleted."
  (:require [hypnos.i18n :refer [tr]]
            [hypnos.lookup :refer (all-makes-by-manufacturer-id
                                   all-models-by-manufacturer-id-make-id)]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Field

(defn field
  ([state]
   (field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   (let [catalog (rf/subscribe [:dme/catalog])]
    [:div.field.is-horizontal
     [:div.field-label.is-normal
      [:label.label (tr :ui.label/mask)]]
     [:div.field-body
      ;; manufacturer
      [:div.field.is-narrow
       [:div.control
        [:div.select.is-fullwidth
         [:select
          {:type      :text
           :disabled  disabled
           :value     (if-let [val (get-in @state [:recommendations :custom :manufacturer :value])]
                        (name val)
                        "")
           :on-change (fn [e]
                        (let [old-value (get-in @state [:recommendations :custom :manufacturer :value])
                              new-value (-> e .-target .-value)
                              new-value (when-not (= "" new-value)
                                          new-value)
                              changed?  (or (get-in @state [:recommendations :custom :manufacturer :dirty?])
                                            (not= new-value old-value))]
                          (swap! state assoc-in
                                 [:recommendations :custom :manufacturer :value]
                                 new-value)
                          (swap! state assoc-in
                                 [:recommendations :custom :manufacturer :dirty?]
                                 changed?)
                          (when changed?
                            (swap! state assoc-in
                                   [:recommendations :custom :make ]
                                   {:value    nil
                                    :dirty?   false
                                    :touched? false})
                            (swap! state assoc-in
                                   [:recommendations :custom :model]
                                   {:value    nil
                                    :dirty?   false
                                    :touched? false}))))
           :on-focus  (fn [_]
                        (swap! state assoc-in
                               [:recommendations :custom :manufacturer :touched?]
                               true))}
          [:option {:value ""} ""]
          (doall
           (for [m (sort-by :manufacturer/name @catalog)]
             [:option {:key (:manufacturer/id m) :value (:manufacturer/id m)} (:manufacturer/name m)]))]]]
       [:p.help (tr :ui.help/manufacturer)]]
      ;; make
      [:div.field.is-narrow
       [:div.control
        [:div.select.is-fullwidth
         [:select
          {:type      :text
           :disabled  (or disabled
                          (nil? (get-in @state [:recommendations :custom :manufacturer :value])))
           :value     (if-let [val (get-in @state [:recommendations :custom :make :value])]
                        (name val)
                        "")
           :on-change (fn [e]
                        (let [old-value (get-in @state [:recommendations :custom :make :value])
                              new-value (-> e .-target .-value)
                              new-value (when-not (= "" new-value)
                                          new-value)
                              changed?  (or (get-in @state [:recommendations :custom :make :dirty?])
                                            (not= new-value old-value))]
                          (swap! state assoc-in
                                 [:recommendations :custom :make :value]
                                 new-value)
                          (swap! state assoc-in
                                 [:recommendations :custom :make :dirty?]
                                 changed?)
                          (when changed?
                            (swap! state assoc-in
                                   [:recommendations :custom :model]
                                   {:value    nil
                                    :dirty?   false
                                    :touched? false}))))
           :on-focus  (fn [_]
                        (swap! state assoc-in
                               [:recommendations :custom :make :touched?]
                               true))}
          [:option {:value ""} ""]
          (doall
           (for [make (sort-by :make/name
                               (all-makes-by-manufacturer-id @catalog
                                                             (get-in @state [:recommendations :custom :manufacturer :value])))]
             [:option {:key (:make/id make) :value (:make/id make)} (:make/name make)]))]]]
       [:p.help (tr :ui.help/mask)]]
      ;; model
      [:div.field.is-narrow
       [:div.control
        [:div.select.is-fullwidth
         [:select
          {:type      :text
           :disabled  (or disabled
                          (nil? (get-in @state [:recommendations :custom :manufacturer :value]))
                          (nil? (get-in @state [:recommendations :custom :make :value])))
           :value     (if-let [val (get-in @state [:recommendations :custom :model :value])]
                        (name val)
                        "")
           :on-change (fn [e]
                        (let [old-value (get-in @state [:recommendations :custom :model :value])
                              new-value (-> e .-target .-value)
                              new-value (when-not (= "" new-value)
                                          new-value)
                              changed?  (or (get-in @state [:recommendations :custom :model :dirty?])
                                            (not= new-value old-value))]
                          (swap! state assoc-in
                                 [:recommendations :custom :model :value]
                                 new-value)
                          (swap! state assoc-in
                                 [:recommendations :custom :model :dirty?]
                                 changed?)))
           :on-focus  (fn [_]
                        (swap! state assoc-in
                               [:recommendations :custom :model :touched?]
                               true))}
          [:option {:value ""} ""]
          (doall
           (for [model (sort-by :model/name
                                (all-models-by-manufacturer-id-make-id @catalog
                                                                       (get-in @state [:recommendations :custom :manufacturer :value])
                                                                       (get-in @state [:recommendations :custom :make :value])))]
             [:option {:key (:model/id model) :value (:model/id model)} (:model/name model)]))]]]
       [:p.help (tr :ui.help/size)]]]])))
